const databaseDownloadSectionName = {
    DATA_SETS : 'Data Sets',

    FORM_TEMPLATES : 'Form Templates',

    RULE_SETS : 'Rule Sets',

    ASSIGNED_AUTHORIZATIONS : 'Assigned Authorizations',

    PRODUCT_TEMPLATES : 'Product Templates',

    ORGANIZATIONS : 'Organizations',

    SECTION_TEMPLATES : 'Section Templates',

    NOTIFICATION_EMAIL_TEMPLATES : 'Notification Email Templates',

    NOTIFICATION_POPUP_TEMPLATES : 'Notification Popup Templates',

    DEFAULT_PREFERENCES : 'Default Preferences',

    SCORING : 'Scoring',

    STATE_RATES : 'State Rates',

    GRID_DEFINTIONS : 'Grid Definitions',

    FILES_AND_ICONS : 'Files & Icons'

};

angular.module('gw-um-j2js')
    .constant('databaseDownloadSectionName', databaseDownloadSectionName);